export default "__VITE_ASSET__CPVwz3HN__"